import React from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

import colorNames from '../../design/color-names'

import {
  StyledThumb,
  StyledThumbOverlay,
  StyledIconWrapper,
  StyledThumbOverlayContainer,
  StyledThumbOverlayContent,
  StyledErrorContent,
  StyledThumbDefaultUploadedImage
} from './Thumb.styles'

export const Thumb = ({
  aspectRatio,
  className,
  HoverComponent,
  hoverComponentProps,
  children,
  onClick,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <StyledThumb
      className={classnames('e-thumb', className)}
      data-mu-test={dataAttributeTest}
      $aspectRatio={aspectRatio}
      onClick={onClick}
    >
      {children}
      {HoverComponent && (
        <StyledThumbOverlay>
          <HoverComponent {...hoverComponentProps} />
        </StyledThumbOverlay>
      )}
    </StyledThumb>
  )
}

Thumb.defaultProps = {
  aspectRatio: 268 / 321
}

Thumb.propTypes = {
  aspectRatio: PropTypes.number,
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  HoverComponent: PropTypes.func,
  hoverComponentProps: PropTypes.object,
  children: PropTypes.node,
  onClick: PropTypes.func
}

const ICON_PREVIEW_WIDTH = 20
const ICON_PREVIEW_HEIGHT = 21

export const ThumbDefaultOverlay = ({
  children,
  className,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <StyledThumbOverlayContainer
      className={className}
      data-mu-test={dataAttributeTest}
    >
      <StyledIconWrapper
        className='e-thumb-overlay-container__icon-wrapper'
        $width={ICON_PREVIEW_WIDTH}
        $height={ICON_PREVIEW_HEIGHT}
        $fill={colorNames.pureWhite}
      >
        <svg
          width={ICON_PREVIEW_WIDTH}
          height={ICON_PREVIEW_HEIGHT}
          viewBox={`0 0 ${ICON_PREVIEW_WIDTH} ${ICON_PREVIEW_HEIGHT}`}
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M19.668 20.2461C19.5898 20.3372 19.4987 20.4023 19.3945 20.4414C19.2904 20.4805 19.1862 20.5 19.082 20.5C18.9779 20.5 18.8737 20.4805 18.7695 20.4414C18.6654 20.4023 18.5742 20.3372 18.4961 20.2461L12.1289 13.8594C11.4909 14.3672 10.7747 14.7708 9.98047 15.0703C9.1862 15.3568 8.34635 15.5 7.46094 15.5C6.43229 15.5 5.46224 15.3047 4.55078 14.9141C3.65234 14.5234 2.86458 13.9896 2.1875 13.3125C1.51042 12.6224 0.976562 11.8216 0.585937 10.9102C0.195312 9.9987 0 9.02865 0 8C0 6.97135 0.195312 6.0013 0.585937 5.08984C0.976562 4.17839 1.51042 3.38411 2.1875 2.70703C2.86458 2.01693 3.65234 1.47656 4.55078 1.08594C5.46224 0.695312 6.43229 0.5 7.46094 0.5C8.48958 0.5 9.45964 0.695312 10.3711 1.08594C11.2826 1.47656 12.0703 2.01693 12.7344 2.70703C13.4115 3.38411 13.9453 4.17839 14.3359 5.08984C14.7396 6.0013 14.9414 6.97135 14.9414 8C14.9414 8.88542 14.7917 9.72526 14.4922 10.5195C14.2057 11.3138 13.8086 12.0299 13.3008 12.668L19.668 19.0742C19.8372 19.2435 19.9219 19.4388 19.9219 19.6602C19.9219 19.8945 19.8372 20.0898 19.668 20.2461ZM7.46094 2.16016C6.66667 2.16016 5.91146 2.31641 5.19531 2.62891C4.49219 2.92839 3.8737 3.34505 3.33984 3.87891C2.81901 4.39974 2.40885 5.01823 2.10937 5.73437C1.8099 6.4375 1.66016 7.19271 1.66016 8C1.66016 8.80729 1.8099 9.56901 2.10937 10.2852C2.40885 10.9883 2.81901 11.6068 3.33984 12.1406C3.8737 12.6615 4.49219 13.0781 5.19531 13.3906C5.91146 13.6901 6.66667 13.8398 7.46094 13.8398C8.26823 13.8398 9.02344 13.6901 9.72656 13.3906C10.4297 13.0781 11.0417 12.6615 11.5625 12.1406C12.0964 11.6068 12.513 10.9883 12.8125 10.2852C13.125 9.56901 13.2812 8.80729 13.2812 8C13.2812 7.19271 13.125 6.4375 12.8125 5.73437C12.513 5.01823 12.0964 4.39974 11.5625 3.87891C11.0417 3.34505 10.4297 2.92839 9.72656 2.62891C9.02344 2.31641 8.26823 2.16016 7.46094 2.16016Z'
            fill='currentColor'
          />
        </svg>
      </StyledIconWrapper>
      {!!children && (
        <StyledThumbOverlayContent className='e-thumb-overlay-container__content'>
          {children}
        </StyledThumbOverlayContent>
      )}
    </StyledThumbOverlayContainer>
  )
}

ThumbDefaultOverlay.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  'data-mu-test': PropTypes.string
}

export const ThumbCustomOverlay = ({
  children,
  className,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <>
      <StyledThumbOverlayContainer
        className={className}
        data-mu-test={dataAttributeTest}
      >
        {children}
      </StyledThumbOverlayContainer>
    </>
  )
}

ThumbCustomOverlay.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  'data-mu-test': PropTypes.string
}

const ICON_ERROR_WIDTH = 20
const ICON_ERROR_HEIGHT = 17

export const ThumbDefaultError = ({
  children,
  className,
  'data-mu-test': dataAttributeTest,
  onClick
}) => {
  return (
    <StyledThumbOverlayContainer
      className={className}
      data-mu-test={dataAttributeTest}
    >
      <StyledIconWrapper
        $width={20}
        $height={17}
        $fill={colorNames.silverChalice}
        className='e-thumb-overlay-container__icon-wrapper'
      >
        <svg
          width={ICON_ERROR_WIDTH}
          height={ICON_ERROR_HEIGHT}
          viewBox={`0 0 ${ICON_ERROR_WIDTH} ${ICON_ERROR_HEIGHT}`}
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M6.22545 3.99086C6.60045 4.36586 6.78795 4.82122 6.78795 5.35693C6.78795 5.89265 6.60045 6.348 6.22545 6.723C5.85045 7.098 5.39509 7.2855 4.85938 7.2855C4.32366 7.2855 3.8683 7.098 3.4933 6.723C3.1183 6.348 2.9308 5.89265 2.9308 5.35693C2.9308 4.82122 3.1183 4.36586 3.4933 3.99086C3.8683 3.61586 4.32366 3.42836 4.85938 3.42836C5.39509 3.42836 5.85045 3.61586 6.22545 3.99086ZM17.0737 9.21408V13.7141H2.9308V11.7855L6.14509 8.57122L7.75223 10.1784L12.8951 5.03551L17.0737 9.21408ZM18.0379 2.14265H1.96652C1.87946 2.14265 1.80246 2.17613 1.73549 2.24309C1.67522 2.30336 1.64509 2.37702 1.64509 2.46408V14.6784C1.64509 14.7654 1.67522 14.8424 1.73549 14.9094C1.80246 14.9697 1.87946 14.9998 1.96652 14.9998H18.0379C18.125 14.9998 18.1987 14.9697 18.2589 14.9094C18.3259 14.8424 18.3594 14.7654 18.3594 14.6784V2.46408C18.3594 2.37702 18.3259 2.30336 18.2589 2.24309C18.1987 2.17613 18.125 2.14265 18.0379 2.14265ZM19.6451 2.46408V14.6784C19.6451 15.1203 19.4877 15.4987 19.173 15.8134C18.8583 16.1281 18.4799 16.2855 18.0379 16.2855H1.96652C1.52455 16.2855 1.14621 16.1281 0.831473 15.8134C0.516741 15.4987 0.359375 15.1203 0.359375 14.6784V2.46408C0.359375 2.02211 0.516741 1.64376 0.831473 1.32903C1.14621 1.0143 1.52455 0.856934 1.96652 0.856934H18.0379C18.4799 0.856934 18.8583 1.0143 19.173 1.32903C19.4877 1.64376 19.6451 2.02211 19.6451 2.46408Z'
            fill='currentColor'
          />
        </svg>
      </StyledIconWrapper>
      {!!children && (
        <StyledErrorContent
          className='e-thumb-overlay-container__content'
          onClick={onClick}
        >
          {children}
        </StyledErrorContent>
      )}
    </StyledThumbOverlayContainer>
  )
}

ThumbDefaultError.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  onClick: PropTypes.func
}

export const ThumbDefaultUploadedImage = StyledThumbDefaultUploadedImage
